import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'vw-camera-icon',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-camera"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></svg>`
})
export class CameraIconComponent {

}
